function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

function SvgCircleYes(props) {
  const light = props.light || '#999';
  const dark = props.dark || '#000';
  return React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 96 96",
    "uc-svg": "www"
  }, props), React.createElement("path", {
    d: "M48 4C23.7 4 4 23.699 4 48s19.7 44 44 44 44-19.699 44-44S72.3 4 48 4zm0 80c-19.882 0-36-16.118-36-36s16.118-36 36-36 36 16.118 36 36-16.118 36-36 36z"
  }), React.createElement("path", {
    d: "M65.172 33.171L43.625 54.718 30.4 44.8a4 4 0 00-4.8 6.4l16 12c.037.028.078.046.116.073.077.054.156.101.236.149a3.993 3.993 0 00.658.319c.155.058.312.102.471.14.072.017.142.039.215.052.232.041.466.067.701.067H44c.282 0 .564-.037.841-.096.084-.018.163-.049.246-.073a3.98 3.98 0 00.558-.198c.098-.044.189-.097.284-.149a4.045 4.045 0 00.729-.516c.055-.049.117-.086.17-.139l24-24a4 4 0 00-5.656-5.658z"
  }));
}

SvgCircleYes.clsName = 'icon-www__circle-yes';
SvgCircleYes.remarkName = 'unknown';
export default SvgCircleYes;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ucloud/ucloud-icons/dist/www/svgr/CircleYes.js
// module id = 2317
// module chunks = 17 18